import React, { useState } from 'react';
import { Grid, Typography, Box, Button, Tooltip } from '@mui/material';
import CustomModal from '../CustomModal/CustomModal';
import background from '../../../../assets/bg1.png';
import Alerts from '../Alerts/Alerts';
import Globspot from "../../../../assets/globspot.png";
import img1 from "../../../../assets/img1.png";

const First = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  
  const [alert, setAlert] = useState({ message: '', severity: 'success' as 'success' | 'error', open: false });
  const showAlert = (message: string, severity: 'success' | 'error') => {
    setAlert({ message, severity, open: true });
  };
  const handleAlertClose = () => {
    setAlert((prevAlert) => ({ ...prevAlert, open: false }));
  };
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  return (
    <Box sx={{
      backgroundImage: `url(${background})`,
      margin: '0 auto',
      padding: '10px',
      backgroundSize: { xs: 'cover', sm: '100% 100%' }, 
      backgroundPosition: 'center',
      height: { xs: '700px', sm: '620px' } // Ajuste de altura en tabletas horizontales
    }}>
      <Box
        component="img"
        src={Globspot}
        alt=""
        sx={{
          display: 'block',
          maxWidth: '100%',
          width: 'auto',
          margin: {
            xs: '0 auto',   // En pantallas pequeñas (xs) centrado
            sm: '0 auto',   // En tabletas horizontales (sm) centrado
            md: '0 100px',  // En pantallas medianas (md) y más grandes, margen de 0 100px
          },
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Grid container spacing={{ xs: 2, sm: 3, md: 5 }} justifyContent="center">
          <Grid item xs={12} md={6} sx={{ color: 'white', textAlign: { xs: 'center', sm: 'center', md: 'left' }, marginTop: { xs: 5, sm: 5, md: 10 } }}>
            <Typography variant="h4" sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '3.2rem' }, fontWeight: "bold" }}>
              Controla tu flotilla
            </Typography>
            <Typography variant="h3" sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem', md: '2.1rem' }, mt: 1, fontWeight: "bold", color: "#CBD5E1" }}>
              Aprovecha un 20% de descuento por Buen Fin
            </Typography>
            <Typography variant="h3" sx={{ fontSize: { xs: '1rem', sm: '1.1rem', md: '1.9rem' }, mt: 2 }}>
              ¿Problemas con la gestión de activos? Este Buen Fin, optimiza el rendimiento y la seguridad de tu flotilla con Globspot, la solución avanzada de telemetría y rastreo satelital. Aprovecha nuestro 20% de descuento en la contratación de todo el paquete. Solicita tu cotización y recibe tu cupón ahora.
            </Typography>
            <Grid item xs={12} textAlign="center">
              <Tooltip title="Canjear cupón">
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{
                    borderRadius: '15px',
                    mt: 3,
                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' }
                  }}
                  onClick={handleOpenModal}
                >
                  Canjear cupón
                </Button>
              </Tooltip>
            </Grid>
          </Grid>

          <Grid item xs={9} md={4} sm={5}>
            <img
              src={img1}
              alt=''
              style={{
                width: '100%',
                maxWidth: '500px',
                height: 'auto',
              }}
            />
          </Grid>
        </Grid>
        <CustomModal
          open={isModalOpen}
          handleClose={handleCloseModal}
          showAlert={showAlert}
        />
        <Alerts 
          message={alert.message} 
          severity={alert.severity} 
          open={alert.open} 
          onClose={handleAlertClose} 
        />
      </Box>
    </Box>
  );
};

export default First;
